/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type RetainAdvancedChatFilesMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  messageID: Types.Scalars['ID']['input']
  fileIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type RetainAdvancedChatFilesMutation = {
  __typename?: 'Mutation'
  retainAdvancedChatFiles: Array<{ __typename?: 'PatientFile'; fileID: string; filename: string; contentType: string }>
}

export const RetainAdvancedChatFilesDocument = gql`
  mutation retainAdvancedChatFiles($uid: ID!, $messageID: ID!, $fileIDs: [ID!]!) {
    retainAdvancedChatFiles(uid: $uid, messageID: $messageID, fileIDs: $fileIDs) {
      fileID
      filename
      contentType
    }
  }
`
export type RetainAdvancedChatFilesMutationFn = Apollo.MutationFunction<
  RetainAdvancedChatFilesMutation,
  RetainAdvancedChatFilesMutationVariables
>

/**
 * __useRetainAdvancedChatFilesMutation__
 *
 * To run a mutation, you first call `useRetainAdvancedChatFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetainAdvancedChatFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retainAdvancedChatFilesMutation, { data, loading, error }] = useRetainAdvancedChatFilesMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      messageID: // value for 'messageID'
 *      fileIDs: // value for 'fileIDs'
 *   },
 * });
 */
export function useRetainAdvancedChatFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<RetainAdvancedChatFilesMutation, RetainAdvancedChatFilesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RetainAdvancedChatFilesMutation, RetainAdvancedChatFilesMutationVariables>(
    RetainAdvancedChatFilesDocument,
    options
  )
}
export type RetainAdvancedChatFilesMutationHookResult = ReturnType<typeof useRetainAdvancedChatFilesMutation>
export type RetainAdvancedChatFilesMutationResult = Apollo.MutationResult<RetainAdvancedChatFilesMutation>
export type RetainAdvancedChatFilesMutationOptions = Apollo.BaseMutationOptions<
  RetainAdvancedChatFilesMutation,
  RetainAdvancedChatFilesMutationVariables
>
